export default {
   // user permissions data 
   getPermissions(state) {
      return state.permissions;
   }
}